import { createSafeContext } from '@/package';

import type { ModelVersionTrainingFormContextValue } from './type';

const ModelVersionTrainingFormContext =
  createSafeContext<ModelVersionTrainingFormContextValue>(
    null,
    'ModelVersionTrainingFormContext',
  );

export default ModelVersionTrainingFormContext;
